export namespace Prop {
  /**
   * ç¹å¾é
   */
  export interface IPropSet {
    id: string;
    /**
     * ç¹å¾éç¼å·
     */
    code: string;
    /**
     * å¨æå­æ®µï¼è¿åå¼ä¸­ä¸å­å¨ï¼ç¨äºå±ç¤ºå½åè¯­è¨çææ¬
     */
    name?: string;
    /**
     * ç¹å¾éåç§°-è±æ
     */
    name_en: string;
    /**
     * ç¹å¾éåç§°-ç®ä½
     */
    name_chs: string;
    /**
     * ç¹å¾éåç§°-ç¹ä½
     */
    name_cht: string;
  }
  /**
   * ç¹å¾é¡¹
   */
  export interface IProp {
    /**
     * ç¹å¾é¡¹id
     */
    id: string;
    /**
     * ç¹å¾é¡¹ç¼å·
     */
    code: string;
    /**
     * ç¼å·å­æ®µï¼æä¸ä½¿ç¨ï¼
     */
    codefield: string;
    /**
     * å¨æå­æ®µ
     */
    name?: string;
    /**
     * ç¹å¾é¡¹åç§°-è±æ
     */
    name_en: string;
    /**
     * ç¹å¾é¡¹ç¼å·-ç®ä½
     */
    name_chs: string;
    /**
     * ç¹å¾é¡¹ç¼å·-ç¹ä½
     */
    name_cht: string;
    /**
     * ç¹å¾å¼
     */
    value: any;
    /**
     * å¼å­æ®µ
     */
    valuefield: string;
    /**
     * ç¹å¾é¡¹å¯¹åºçè¾å¥æ§ä»¶ç±»å
     */
    inputtype: string;
    /**
     * æ°å­ç²¾åº¦
     */
    digitalaccuracy: number;
    /**
     * ç¹å¾éid
     */
    setid: string;
    helpid: string;
    /**
     * æä¸¾æ°æ®æº
     * @attention æ¥å£è¿åç»æä¸ºå­ç¬¦ä¸²
     */
    enuminfo: string;
    /**
     * æä¸¾æ°æ®æº
     */
    data: IEnumInfo[];
    /**
     * æ åä»£ç éæ¯å¦ä¸ºæ 
     */
    setistree: string;
    /**
     * æ åä»£ç éid
     */
    codesetid: string;
    /**
     * ææ¬å­æ®µ
     */
    textfield: string;
    /**
     * è¿æ»¤æ¡ä»¶
     */
    filtercondition: any;
    /**
     * å¿å¡«
     */
    isrequired: string | boolean;
    /**
     * åªè¯»
     */
    isreadonly: string | boolean;
    /**
     * æåº
     */
    sortorder: number;

    timestamp_createdon: string;
    timestamp_lastchangedon: string;

    timestamp_createdby: string;
    timestamp_lastchangedby: string;

  }
  /**
   * æä¸¾æ°æ®æºæ ¼å¼
   */
  export interface IEnumInfo {
    id: string;
    text: string;
  }
  export interface IReturnValue {
    propset: IPropSet[],
    props: IProp[]
  }
  export enum InputType {
    enum = 'Enum',
    string = 'String',
    help = 'Help',
    number = 'Number',
    date = 'Date'
  }
}
